
export default function IconKey() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Key">
        <g id="Vector">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 21.9999C20 21.9999 18.4049 22.0059 16.9048 21.5093L15.7071 22.707C15.5196 22.8945 15.2652 22.9999 15 22.9999H13V24.9999C13 25.5522 12.5523 25.9999 12 25.9999H10V27.9999C10 28.5522 9.55228 28.9999 9 28.9999H4C3.44772 28.9999 3 28.5522 3 27.9999V22.9999C3 22.7347 3.10536 22.4803 3.29289 22.2928L10.4906 15.095C10.4906 15.095 9.994 13.5943 10 11.9961C10 11.9961 10 8.96641 11.6853 6.44418C11.6853 6.44418 13.3706 3.92194 16.1732 2.76109C16.1732 2.76109 18.9757 1.60023 21.9509 2.19203C21.9509 2.19203 24.9261 2.78383 27.0711 4.92881C27.0711 4.92881 29.2161 7.07379 29.8079 10.049C29.8079 10.049 30.3997 13.0241 29.2388 15.8267C29.2388 15.8267 28.0779 18.6293 25.5557 20.3146C25.5557 20.3146 23.0335 21.9999 20 21.9999ZM20 19.9999C20 19.9999 18.4557 20.0057 17.029 19.4245L17.0275 19.4239C16.7819 19.3237 16.5066 19.3253 16.2621 19.4282C16.1428 19.4784 16.0344 19.5513 15.9429 19.6428L14.5858 20.9999H12C11.4477 20.9999 11 21.4476 11 21.9999V23.9999H9C8.44772 23.9999 8 24.4476 8 24.9999V26.9999H5V23.4141L12.3571 16.057C12.6417 15.7724 12.7279 15.3451 12.576 14.9724C12.576 14.9724 11.9942 13.545 12 12.0036C12 12.0036 12 9.57311 13.3482 7.55532C13.3482 7.55532 14.6965 5.53753 16.9385 4.60885C16.9385 4.60885 19.1806 3.68016 21.5607 4.1536C21.5607 4.1536 23.9409 4.62704 25.6569 6.34303C25.6569 6.34303 27.3728 8.05901 27.8463 10.4392C27.8463 10.4392 28.3197 12.8193 27.391 15.0613C27.391 15.0613 26.4624 17.3034 24.4446 18.6516C24.4446 18.6516 22.4268 19.9999 20 19.9999Z"
            fill="#1C1C1C"
          />
          <path
            d="M24 9.5C24 10.3284 23.3284 11 22.5 11C21.6716 11 21 10.3284 21 9.5C21 8.67157 21.6716 8 22.5 8C23.3284 8 24 8.67157 24 9.5Z"
            fill="#1C1C1C"
          />
        </g>
      </g>
    </svg>
  );
}
